<template>
  <refonte-page-alert
    v-bind:description_in_card="true"
    v-bind:alert_type="'error'"
    v-bind:start_date="'2026-04-08T05:00:00'"
    v-bind:end_date="'2026-04-13T08:00:00'">
    La plateforme JINIUS sera indisponible le lundi 13/4 entre 7h et 9h pour une
    intervention technique. Veuillez nous excuser pour la gêne occasionnée.
  </refonte-page-alert>
  <navigation
    v-bind:sub_components_list="subComponentsList"
    v-bind:labels="labels"
    v-bind:default_key="'sessions'"
    v-bind:sync_with_route="true" />
</template>

<script setup lang="ts">
  import navigation from '@/views/_espace/_refonte/formateur/utils/navigation.vue';

  import sessions from '@/views/_espace/_refonte/formateur/_sessions/sessions.vue';
  import sessionsdone from '@/views/_espace/_refonte/formateur/_sessions/sessionsdone.vue';
  import RefontePageAlert from '@/components/refonte/alerts/refonte-page-alert.vue';

  const labels: Record<string, string> = {
    sessionsdone: 'Sessions terminées',
    sessions: 'Prochaines sessions'
  };

  const subComponentsList = {
    sessions,
    sessionsdone
  };
</script>

<style lang="scss" scoped></style>
